import React from 'react';
import { useCases } from '../mock';
import { ArrowRight } from 'lucide-react';

const UseCasesSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 via-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Use Cases
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real-world applications of E2-Return tracking system
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {useCases.map((useCase) => (
            <div 
              key={useCase.id} 
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="aspect-video relative overflow-hidden">
                <img 
                  src={useCase.image}
                  alt={useCase.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {useCase.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {useCase.description}
                </p>
                <div className="flex items-center text-blue-900 font-semibold group-hover:text-red-600 transition-colors">
                  <span className="text-sm">Explore solution</span>
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
